export const fr = {
  'nav.dashboard': 'Tableau de bord',
  'nav.conception': 'Conception',
  'nav.planification': 'Planification',
  'nav.pilotage': 'Pilotage',
  'nav.marketplaceCrm': 'Marketplace & CRM',
  'nav.network': 'Réseau & savoirs',
  'nav.accompagnement': 'Accompagnement',
  'nav.concours': 'Concours',
  'nav.assistance': 'Assistance',
  'nav.projects': 'Mes projets',
  'nav.subscription': 'Abonnement',
  'nav.profile': 'Profil',
  'nav.signOut': 'Déconnexion',
  'nav.group.parcours': 'Parcours',
  'nav.group.outils': 'Outils & communauté',
  'nav.group.compte': 'Mon espace',
  'nav.more': 'Plus',
  'nav.moreTitle': 'Autres rubriques',
  'nav.short.dashboard': 'Accueil',
  'nav.short.conception': 'Concept',
  'nav.short.planification': 'Planif',
  'nav.short.pilotage': 'Pilotage',
  'nav.short.marketplaceCrm': 'Market',
  'shell.eyebrow': 'Espace entrepreneur',
  'shell.menu': 'Menu',
  'shell.close': 'Fermer',
  'shell.role.entrepreneur': 'Entrepreneur',
  'lang.fr': 'FR',
  'lang.en': 'EN',
  'mkt.nav.homeAria': 'ISBD — accueil',
  'mkt.nav.menu': 'Menu',
  'mkt.nav.parcours': 'Parcours',
  'mkt.nav.offres': 'Offres',
  'mkt.nav.marketplace': 'Marketplace',
  'mkt.nav.equipe': 'Équipe',
  'mkt.nav.contact': 'Contact',
  'mkt.nav.login': 'Connexion',
  'mkt.nav.register': 'Créer un compte',
  'mkt.footer.tagline':
    'Integrated System for Business Development — de l’idée à l’entreprise durable en Afrique.',
  'mkt.footer.discover': 'Découvrir',
  'mkt.footer.services': 'Services',
  'mkt.footer.legal': 'Légal',
  'mkt.footer.presentation': 'Présentation',
  'mkt.footer.parcours': 'Parcours',
  'mkt.footer.offres': 'Offres',
  'mkt.footer.equipe': 'Équipe',
  'mkt.footer.marketplace': 'Marketplace',
  'mkt.footer.concours': 'Concours Excellence Entrepreneurial',
  'mkt.footer.contact': 'Contact',
  'mkt.footer.register': 'Inscription',
  'mkt.footer.privacy': 'Politique de confidentialité',
  'mkt.footer.terms': 'Conditions d’utilisation',
  'mkt.footer.writeUs': 'Nous écrire',
  'mkt.footer.login': 'Connexion',
  'mkt.footer.createAccount': 'Créer un compte',
  'mkt.footer.rights': '© {year} ISBD. Tous droits réservés.',
  'home.hero.kicker': 'Système panafricain de développement entrepreneurial',
  'home.hero.titleBefore': 'De l’idée à l’entreprise durable, ',
  'home.hero.titleEm': 'un seul système intégré',
  'home.hero.lead':
    'ISBD accompagne les entrepreneurs africains à chaque étape : idéation, faisabilité, plan d’affaires, déploiement et pilotage — avec les ressources pour réussir.',
  'home.hero.ctaStart': 'Démarrer mon projet',
  'home.hero.ctaDiscover': 'Découvrir le parcours',
  'home.stats.aria': 'Chiffres clés',
  'home.stats.stepsLabel': 'étapes',
  'home.stats.stepsText': 'de l’idéation à la rentabilité',
  'home.stats.fundingLabel': 'financement',
  'home.stats.fundingText': 'possible via le concours Excellence',
  'home.stats.circlesLabel': 'cercles',
  'home.stats.circlesText': 'd’accompagnement dédiés',
  'home.parcours.eyebrow': 'Le parcours ISBD',
  'home.parcours.title': 'Un système intégré, du concept au succès durable',
  'home.parcours.lead':
    'Chaque étape est outillée numériquement et adossée à un accompagnement stratégique, ancré dans les réalités du continent.',
  'home.parcours.alt': 'Entrepreneurs africains collaborant sur leur projet',
  'home.step1.title': 'Idéation',
  'home.step1.text': 'Structurer et qualifier l’idée d’affaires dès son origine.',
  'home.step2.title': 'Étude & plan d’affaires',
  'home.step2.text': 'Faisabilité, modélisation financière et business plan.',
  'home.step3.title': 'Planification',
  'home.step3.text': 'Organiser les ressources et préparer le déploiement.',
  'home.step4.title': 'Déploiement & pilotage',
  'home.step4.text': 'Lancer le projet et piloter l’exécution au quotidien.',
  'home.step5.title': 'Rentabilité & durabilité',
  'home.step5.text': 'Ancrer la performance et la pérennité de l’activité.',
  'home.offres.eyebrow': 'Nos offres',
  'home.offres.title': 'Tout ce qu’il faut pour construire une entreprise qui dure',
  'home.offres.lead': 'Quatre familles de services complémentaires, sur tout le cycle entrepreneurial.',
  'home.offer1.title': 'Conception de projet',
  'home.offer1.text':
    'Idéation guidée, études de faisabilité et modélisation de plan d’affaires assistées numériquement.',
  'home.offer1.alt': 'Entrepreneurs africains collaborant sur un projet',
  'home.offer2.title': 'Planification & déploiement',
  'home.offer2.text': 'Des outils concrets pour organiser et lancer le projet dans de bonnes conditions.',
  'home.offer2.alt': 'Équipe d’entrepreneurs africains en session de planification',
  'home.offer3.title': 'Pilotage de la productivité',
  'home.offer3.text':
    'Un suivi structuré de l’activité pour garantir l’exécution et la performance dans la durée.',
  'home.offer3.alt': 'Professionnels africains en réunion de pilotage',
  'home.offer4.title': 'Accompagnement stratégique',
  'home.offer4.text': 'Un appui de fond pour transformer l’activité en entreprise rentable et durable.',
  'home.offer4.alt': 'Accompagnement stratégique entre entrepreneurs africains',
  'home.concours.eyebrow': 'Financement',
  'home.concours.title': 'Concours Excellence Entrepreneurial',
  'home.concours.lead':
    'Financer les projets viables et porteurs d’impact. Gratuit, réservé aux abonnés ISBD — jusqu’à 15 000 €, remboursable sans intérêt sur trois ans.',
  'home.concours.point1': 'Concours général — ouvert à tous les abonnés',
  'home.concours.point2': 'Concours Ambassadeurs — jusqu’à 250 projets / an',
  'home.concours.point3': 'Concours spécial — appels partenaires',
  'home.concours.cta': 'Devenir abonné',
  'home.marketplace.eyebrow': 'Marketplace ISBD',
  'home.marketplace.title': 'La boutique des abonnés, ouverte à tous les visiteurs',
  'home.marketplace.lead':
    'Les abonnés publient leurs produits et services. Les visiteurs consultent les fiches et contactent le vendeur — l’abonné reçoit l’expression de besoin avec les références du client dans son espace.',
  'home.marketplace.aria': 'Ambiances marketplace',
  'home.marketplace.cta': 'Découvrir la marketplace',
  'home.cat.mode': 'Mode',
  'home.cat.agro': 'Agro-industrie',
  'home.cat.commerce': 'Commerce',
  'home.cat.services': 'Services',
  'home.cat.production': 'Production',
  'home.cat.logistics': 'Logistique',
  'home.ambition.title':
    'Faire émerger une nouvelle génération d’entreprises africaines rentables et durables',
  'home.ambition.lead':
    'ISBD se veut le système de référence pour le développement entrepreneurial sur le continent — digital, structuré et pensé pour les réalités des entrepreneurs africains.',
  'home.team.eyebrow': 'Notre équipe',
  'home.team.title': 'Trois cercles d’accompagnement autour de vous',
  'home.team.lead':
    'Chaque entrepreneur est entouré de trois profils complémentaires, mobilisables selon le besoin.',
  'home.circle1.title': 'Mentors',
  'home.circle1.text':
    'Des entrepreneurs expérimentés pour partager leur expérience et éviter les erreurs destructrices.',
  'home.circle1.alt': 'Entrepreneur mentor',
  'home.circle2.title': 'Experts formateurs',
  'home.circle2.text':
    'Des spécialistes pour développer votre savoir-faire et votre posture d’entrepreneur.',
  'home.circle2.alt': 'Experte formatrice en business',
  'home.circle3.title': 'Conseillers d’affaires',
  'home.circle3.text':
    'Des experts du business development pour vous accompagner pas à pas dans la croissance.',
  'home.circle3.alt': 'Équipe de conseillers en réunion',
  'home.final.title': 'Prêt à structurer votre projet avec ISBD ?',
  'home.final.lead': 'Rejoignez le système intégré — de l’idée à la rentabilité.',
  'home.final.ctaRegister': 'Créer un compte',
  'home.final.ctaContact': 'Nous contacter',
  'pres.eyebrow': 'Présentation',
  'pres.title': 'Le parcours ISBD',
  'pres.lead':
    'Un accompagnement structuré de l’idée à l’exploitation, outillé et piloté — pensé pour les entrepreneurs du continent africain.',
  'pres.alt': 'Entrepreneur accompagné dans son parcours',
  'pres.cta': 'Rejoindre la plateforme',
  'sub.title': 'Abonnement',
  'sub.subtitle': 'Choisissez la formule adaptée à votre parcours entrepreneurial et accéder à toutes les fonctionnalités du système.',
  'sub.current': 'Plan actuel',
  'sub.none': 'Aucun',
  'sub.trial': 'Essai gratuit',
  'sub.pay': 'Payer',
  'sub.payNext': 'Payer l’échéance suivante',
  'sub.currentPlan': 'Plan actuel',
  'sub.history': 'Historique',
  'sub.trialBanner': 'Essai gratuit : {days} jour(s) restant(s).',
  'sub.lockedBanner':
    'Votre période d’essai est terminée. Votre compte reste accessible ; souscrivez pour débloquer les fonctionnalités.',
  'sub.pendingBanner':
    'Paiement en attente pour le plan {plan}. L’abonnement ne sera activé qu’après confirmation du paiement.',
  'sub.paymentSuccess': 'Paiement confirmé. Votre abonnement est maintenant actif.',
  'sub.paymentPending':
    'Votre paiement n’est pas confirmé. L’abonnement n’est pas activé.',
  'sub.paymentError': 'Le paiement a échoué ou a été annulé.',
  'sub.installments': '{paid}/{total} échéance(s) payée(s)',
  'sub.nextDue': 'Prochaine échéance : {date}',
  'sub.endsOn': 'Fin d’abonnement : {date}',
  'sub.alertTrialExpiring':
    'Votre essai gratuit se termine dans {days} jour(s). Souscrivez un plan pour conserver l’accès.',
  'sub.alertSubscriptionExpiring':
    'Votre abonnement {plan} expire dans {days} jour(s). Renouvelez pour éviter toute interruption.',
  'sub.alertInstallmentDueSoon': 'Une échéance de paiement est due dans {days} jour(s).',
  'sub.alertInstallmentDueToday': 'Une échéance de paiement est due aujourd’hui.',
  'sub.alertInstallmentOverdue': 'Une échéance de paiement est en retard. Régularisez pour maintenir votre accès.',
  'sub.alertAction': 'Gérer mon abonnement',
  'sub.subscriptionEndedBanner':
    'Votre abonnement est arrivé à échéance. Renouvelez pour retrouver l’accès aux fonctionnalités.',
  'access.lockedTitle': 'Fonctionnalités verrouillées',
  'access.lockedBody':
    'Votre essai de 14 jours est terminé. Vous pouvez consulter votre profil et souscrire un abonnement.',
  'access.goSubscribe': 'Voir les abonnements',
  'profile.referralTitle': 'Parrainage',
  'profile.referralShare': 'Partagez ce lien :',
  'profile.referralCount': '{count} personne(s) parrainée(s) sur ce cycle',
  'profile.referralResetHint': 'Le compteur est réinitialisé à chaque réabonnement.',
  'profile.konan': 'ID KONAN',
  'profile.vouchers': 'Bons d’achat',
  'premium.badge': 'Boutique Premium',
  'premium.title': 'Produits sélectionnés et vérifiés par ISBD',
  'premium.empty':
    'Une sélection de produits et services premium, vérifiés et recommandés par ISBD.',
  'premium.cta': 'Voir le produit vedette →',
} as const;

export type MessageKey = keyof typeof fr;
export type FrMessages = typeof fr;
